module.exports = function() {
  return new Worker(__webpack_public_path__ + "1c6dc7cb6a3d3df81c3e.worker.js");
};